/**
 * @lodex-pro/web-portal/public/PublicLayout — minimal branded shell for public routes.
 *
 * Phase 15 followup (DEC-155) — wraps /portal/register and /portal/verify with a
 * centered dark-theme layout. NO nav, NO sign-out, NO usePortalMe (that hook 401s
 * for anonymous users). Renders <Outlet /> for child routes.
 *
 * Branding: "lodeX Pro Portal" (tenant-facing brand, not "Paelode Systems" which
 * is reserved for invoices + internal admin per CLAUDE.md).
 *
 * Styling: inline styles matching PortalShell.tsx colour palette
 *   background: #0b0f19, color: #e5e7eb, header border: #1f2937
 * Container: max-width 480px, centered, 32px padding.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';

export function PublicLayout(): React.JSX.Element {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--color-bg-primary)',
        color: 'var(--color-text-primary)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <header
        style={{
          padding: '16px 24px',
          borderBottom: '1px solid var(--color-border-primary)',
          background: 'var(--color-bg-rail)',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            fontWeight: 700,
            fontSize: '16px',
            color: 'var(--color-text-primary)',
          }}
        >
          lodeX Pro Portal
        </span>
      </header>
      <div
        style={{
          maxWidth: '480px',
          margin: '0 auto',
          padding: '32px 16px',
        }}
      >
        <Outlet />
      </div>
    </div>
  );
}
